export default "__VITE_ASSET__CVYCtCHq__"